import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('MANAGEMENT_RQ', ['FORM'])
